export const isEmpty = (obj: any): boolean =>
  !Object.entries(obj || {}).length && !obj?.length && !obj?.size;

export const truncateString = (str: string, num: number) => {
  if (str.length <= num) {
    return str;
  }

  return str.slice(0, num) + '...';
};

export const upperFirst = (value: string): string => {
  if (!value) return '';

  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
};

export const decodeHtmlEntities = (html: string): string => {
  if (!html) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.documentElement.textContent || '';
};

export const normalizeSpaces = (html: string): string => {
  if (!html) return '';

  const decoded = decodeHtmlEntities(html);
  return decoded.replace(/\s+/g, ' ').trim();
};

export const processMessageText = (text: string): string => {
  if (!text) return '';

  return text
    .replace(/&nbsp;/g, ' ')
    .replace(/&ensp;/g, ' ')
    .replace(/&emsp;/g, ' ')
    .replace(/&thinsp;/g, ' ')
    .replace(/&zwnj;/g, '')
    .replace(/&zwj;/g, '')
    .replace(/\s+/g, ' ');
};

export const ellipsis = (
  text: string,
  maxLength: number,
  position: 'end' | 'middle' = 'end',
): string => {
  if (!text || typeof text !== 'string') return '';
  if (text.length <= maxLength) return text;
  if (maxLength < 4) return '';

  if (position === 'middle') {
    const halfLength = Math.floor((maxLength - 3) / 2);
    const remainingLength = maxLength - 3 - halfLength;

    return (
      text.substring(0, halfLength) +
      '...' +
      text.substring(text.length - remainingLength)
    );
  }

  return text.substring(0, maxLength - 3) + '...';
};
